import React, { useRef } from "react";
import { Snackbar } from "@mui/material";
import NewRecordingModal from "./NewRecordingModal";
import { useRecordingFlow } from "../../hooks/useRecordingFlow";

/**
 * Thin wrapper for "Add Recording" modal on route config pages.
 * Uses shared useRecordingFlow hook and calls setRecordings + setOpen on success.
 * When opened from route config with a callback, auto-selects the new recording.
 */
function AddRecordingFlowWrapper({ open, setOpen, setRecordings, recordings = [], callRecordingAddedAndClear }) {
  const recordingsRef = useRef(recordings);
  recordingsRef.current = recordings;

  const recordingFlow = useRecordingFlow({
    onSuccess: (updatedRecordings) => {
      setRecordings(updatedRecordings);
      if (callRecordingAddedAndClear) {
        const prevIds = new Set(
          (recordingsRef.current || [])
            .map((r) => r.M?.rec_id?.S)
            .filter(Boolean)
        );
        const newRec =
          updatedRecordings?.find(
            (r) => r.M?.rec_id?.S && !prevIds.has(r.M.rec_id.S)
          ) ||
          (updatedRecordings?.length
            ? updatedRecordings[updatedRecordings.length - 1]
            : null);
        const newId = newRec?.M?.rec_id?.S;
        if (newId) {
          callRecordingAddedAndClear(newId);
        }
      }
      setOpen(false);
    },
  });

  const {
    record_type,
    setRecordType,
    recording_data,
    setRecordingData,
    handleFileUpload,
    handleClick,
    buttonState,
    formatTime,
    time,
    maxTime,
    restartRecording,
    storeRecording,
    openSnack,
    setOpenSnack,
    snackMsg,
    setSnackMsg,
    fileInputRef,
    uploadedFile,
    audioPreviewUrl,
    isConverting,
    isRecording,
    setUploadedFile,
    step,
    setStep,
  } = recordingFlow;

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openSnack}
        onClose={() => setOpenSnack(false)}
        message={snackMsg}
        key={snackMsg}
      />
      <NewRecordingModal
        open={open}
        setOpen={setOpen}
        recordingData={recording_data}
        setRecordingData={setRecordingData}
        recordType={record_type}
        setRecordType={setRecordType}
        handleFileUpload={handleFileUpload}
        handleClick={handleClick}
        buttonState={buttonState}
        formatTime={formatTime}
        time={time}
        maxTime={maxTime}
        restartRecording={restartRecording}
        storeRecording={storeRecording}
        openSnack={openSnack}
        setOpenSnack={setOpenSnack}
        snackMsg={snackMsg}
        setSnackMsg={setSnackMsg}
        fileInputRef={fileInputRef}
        uploadedFile={uploadedFile}
        audioPreviewUrl={audioPreviewUrl}
        isConverting={isConverting}
        isRecording={isRecording}
        setUploadedFile={setUploadedFile}
        step={step}
        setStep={setStep}
      />
    </>
  );
}

export default AddRecordingFlowWrapper;
